import React from "react"
import "./Home.css"
import HomeHeader from "./HomeHeader";
import UsImg from "./UsImg";
import Sidebar from "./Sidebar";
import {Link} from "react-router-dom";

export default function Home() {
    return (
        <div id="home-page">
            <div id="main-content">
                <HomeHeader/>
                <nav className="nav-links">
                    <Link to="/quiz">Quiz</Link>
                </nav>
                {/*<Sidebar/>*/}
                <UsImg/>
            </div>
        </div>
    )
}